import SaascadaVueForm from '@/components/Shared/SaascadaVueForm';

export default class SaascadaVueDialog extends SaascadaVueForm {
  public dialog = false;
}
